import { useLocation } from "react-router-dom";

import { IAdminRouteGroup } from "../../../@types/AdminRoute";
import { ChevronDown } from "../../../assets/icons/ChevronDown";
import { AdminMenuGroup } from "./AdminMenuGroup";
import { AdminMenuItem } from "./AdminMenuItem";
import {
  CollapseToggleButton,
  Container,
  MenuList,
  SidebarHeader,
  StyledAccordion,
} from "./AdminSidebar.styles";

interface IAdminSidebarProps {
  items: IAdminRouteGroup[];
  mobileMenuOpen?: boolean;
  collapsed?: boolean;
  onToggleCollapse?: () => void;
}

export function AdminSidebar({
  items,
  mobileMenuOpen = false,
  collapsed = false,
  onToggleCollapse,
}: IAdminSidebarProps) {
  const location = useLocation();

  if (items.length === 0) {
    return null;
  }

  const getDefaultOpenGroups = (): string[] => {
    const openGroups: string[] = [];

    items.forEach((route) => {
      if (route.children) {
        const isChildActive = route.children.some(
          (child) => location.pathname === child.path
        );
        if (isChildActive) {
          openGroups.push(route.name);
        }
      }
    });

    return openGroups;
  };

  const renderMenuItem = (route: IAdminRouteGroup) => {
    if (route.children && route.children.length > 0) {
      return <AdminMenuGroup key={route.name} group={route} />;
    }

    if (route.path) {
      return (
        <AdminMenuItem
          key={route.path}
          name={route.name}
          path={route.path}
          Icon={route.Icon}
        />
      );
    }

    return null;
  };

  return (
    <Container mobileMenuOpen={mobileMenuOpen} collapsed={collapsed}>
      <SidebarHeader collapsed={collapsed}>
        {onToggleCollapse && (
          <CollapseToggleButton
            type="button"
            onClick={onToggleCollapse}
            collapsed={collapsed}
            aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            <ChevronDown />
          </CollapseToggleButton>
        )}
      </SidebarHeader>

      {!collapsed && (
        <MenuList>
          <StyledAccordion
            type="multiple"
            defaultValue={getDefaultOpenGroups()}
          >
            {items.map(renderMenuItem)}
          </StyledAccordion>
        </MenuList>
      )}
    </Container>
  );
}
